import root from "./components/root";

document.addEventListener("DOMContentLoaded", root);



// WEBPACK FOOTER //
// ./js/entry.js